<template>
  <section class="assist-board">
    <div class="card">
      <div class="card-body text-center my-1">
        <div class="row">
          <div class="col">
            <p>지금시각</p>
            <p class="h2">{{ timestamp }}</p>
          </div>
          <div class="col">
            <p>방상태</p>
            <p class="h2">
              {{ room.status ? room.status : "서버 대기중" }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body text-center my-1">
        <div class="row">
          <div class="col">
            <p>시작시간</p>
            <p class="h2">{{ formattedStartedAt }}</p>
          </div>
          <div class="col">
            <p>진행시간</p>
            <p class="h2">{{ room.startedAt ? runningTime : '00:00' }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body text-center my-1">
        <div class="row">
          <div class="col">
            <p>풀이시간</p>
            <p class="h2">{{ room.quizTimeLimit }}초</p>
          </div>
          <div class="col">
            <p>현재 퀴즈 / 총 퀴즈</p>
            <p class="h2">{{ publishedQuizIndex + quizIndexOffset}} / {{ totalNumberOfQuizzes }}</p>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body text-center my-1">
        <div class="row">
          <div class="col">
            <p>시청자 / 참여자</p>
            <p class="h2">{{ room.totalWatchers }} / {{ room.totalParticipants }}</p>
          </div>
          <div class="col">
            <p>정답자</p>
            <p class="h2">{{ latestNumberOfRight }}({{ rightAnswererRatio }}%)</p>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body text-center my-1">
        <div class="row">
          <div class="col">
            <p>상금 / 변환</p>
            <p class="h2">{{ room.prize }} coin / {{ prizeConverted }} won</p>
          </div>
          <div class="col">
            <p>기대상금 / 변환</p>
            <p class="h2">{{ expectedPrize }} coin / {{ expectedPrizeConverted }} won</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  mapState,
  mapGetters
} from 'vuex'
import l from '@/vendor/logger'
import now from '@/mixins/now'
import numToKor from '@/mixins/numToKor'

export default {
  name: 'StudioStatus',

  mixins: [now, numToKor],

  created () {
  },

  data () {
    return {
    }
  },

  computed: {
    ...mapGetters('room', [
      'prizeKor',
      'prizeConverted',
      'prizeConvertedKor',
      'formattedStartedAt',
      'quizIndexOffset',
      'publishedQuizIndex'
    ]),
    ...mapState('room', [
      'room'
    ]),
    ...mapGetters('quizzes', [
      'latestNumberOfRight',
      'totalNumberOfQuizzes',
      'latestNumberOfSelectCount',
      'latestTotalParticipants'
    ]),
    ...mapState('quizzes', [
      'numberOfRight'
    ]),
    ...mapState([
      'mode'
    ]),
    expectedPrizeKor () {
      if (this.room.prize && this.latestNumberOfRight > 0) {
        l.d('studio/StudioStatusVertical/expectedPrizeKor', this.room.prize, this.latestNumberOfRight)
        return this.numToKor(
          this.room.prize / this.latestNumberOfRight
        )
      }
    },
    expectedPrize () {
      if (this.room.prize && this.latestNumberOfRight && this.room.prizeRatio) {
        const p = this.room.prize / this.latestNumberOfRight
        return parseInt(p * 10000) / 10000.0
      }
    },
    expectedPrizeConvertedKor () {
      if (this.room.prize && this.latestNumberOfRight && this.room.prizeRatio) {
        return this.numToKor(
          this.room.prize / this.latestNumberOfRight * this.room.prizeRatio
        )
      }
    },
    expectedPrizeConverted () {
      if (this.room.prize && this.latestNumberOfRight && this.room.prizeRatio) {
        const p = this.room.prize / this.latestNumberOfRight * this.room.prizeRatio
        return parseInt(p * 10000) / 10000.0
      }
    },
    rightAnswererRatio () {
      if (this.room.totalParticipants && this.latestNumberOfRight > 0) {
        return Math.round(this.latestNumberOfRight / this.latestTotalParticipants * 100)
      }
    }
  },

  watch: {
    rstatus (newRstatus, oldRstatus) {
      if (newRstatus === 'END') {
        this.stopTimer()
      }
    }
  }
}
</script>

<style scoped>
.assist-board {
  & .card-body {
    padding-top: .5rem;
    padding-bottom: .5rem;
  }
}
</style>
